import HeaderSix from './component.styles'
export default HeaderSix
